import { Component, OnInit } from '@angular/core';
import { ActivatedRoute } from '@angular/router';
import { Observable, ReplaySubject, Subscription } from 'rxjs';
import { FleetAuthField, FleetAuth, FleetAuthLetter, FleetAuthorisation} from 'src/app/models/fleetauth';
import { FleetAuthService } from '../fleet-auth.service';
import { NotificationService } from 'src/app/shared/notification.service'; 
import { ThemeService } from 'src/app/theme.service';
import { QuoteCommunication } from 'src/app/models/communication';
import { AuthService } from 'src/app/auth.service';
import { SendReportService } from 'src/app/widgets/send-report/send-report.service';
import { FormControl, FormGroup, Validators } from '@angular/forms';
import { ReportsService } from 'src/app/shared/reports.service';
import { DomSanitizer } from '@angular/platform-browser';

@Component({
  selector: 'app-callcentre-fleet-auth',
  templateUrl: './callcentre-fleet-auth.component.html',
  styleUrls: ['./callcentre-fleet-auth.component.less']
})
export class CallcentreFleetAuthComponent implements OnInit {
  paramsSub: Subscription;
  authData: FleetAuth = new FleetAuth();
  fleetAuthForm: FleetAuthorisation = new FleetAuthorisation();
  // base64Document: string | ArrayBuffer | null = null;

  timeSinceEmailed: string = '';
  fileUpload: string = '';
  initialAuthStatus: boolean = false;
  hasAuthLetter: boolean = false;
  authLetterBase64: string | null = null;

  isLocked: boolean = false;

  sendAuthorizationForm: FormGroup = new FormGroup({
    isAuthorised: new FormControl({value: undefined, disabled: this.authData.isLocked}, [Validators.required]),
    authNumber: new FormControl({value: "", disabled: this.authData.isLocked}),
    authLetter: new FormControl({value: "", disabled: this.authData.isLocked}),
    message: new FormControl({value: "", disabled: this.authData.isLocked}),
  });

  isLoading: boolean = false;
  constructor(
    private route: ActivatedRoute,
    private notification: NotificationService,
    private fleetAuthService: FleetAuthService,
    public themeService: ThemeService, 
    public authService: AuthService,
    public sendReportService: SendReportService,
    private reports: ReportsService,
    public sanitizer: DomSanitizer
    ) { }

  ngOnInit() {
    
    this.paramsSub = this.route.params.subscribe(params => {
      this.loadFleetAuthData(params['quoteid'], params['sfref']);
    });
  }

  loadFleetAuthData(quoteId: number, sfRef: string) {
    this.fleetAuthService.getfleetAuthDataCallCentre(quoteId, sfRef).subscribe({next: (data: FleetAuth) => {
      this.authData = data;
      this.isLocked = (this.authData.isLocked === true && !!this.authData.quoteId) ? true : false;

      this.sendAuthorizationForm = new FormGroup({
        isAuthorised: new FormControl({value: undefined, disabled: this.isLocked}, [Validators.required]),
        authNumber: new FormControl({value: "", disabled: this.isLocked}, [Validators.required]),
        authLetter: new FormControl({value: "", disabled: this.isLocked}),
        message: new FormControl({value: "", disabled: this.isLocked}),
      });
      if (this.authData.dtEmailed && this.authData.dtResponded) {
        this.timeSinceEmailed = this.calculateTimeSinceEmailed(new Date(this.authData.dtResponded + 'Z'), new Date(this.authData.dtEmailed + 'Z'));
      }
      else if (this.authData.dtEmailed) {
        this.timeSinceEmailed = this.calculateTimeSinceEmailed(new Date(this.authData.dtEmailed + 'Z'), new Date());
        // this.timeResponded = this.calculateTimeSinceEmailed(this.authData.dtEmailed);
      }
    },
    error: err => this.notification.handleError(err)});
  }

  calculateTimeSinceEmailed(dtOld: Date, dtNew: Date): string {
    const now = dtNew;
    const emailedDate = dtOld;

    const timeDiff = Math.abs(now.getTime() - emailedDate.getTime());
    const diffSeconds = Math.floor(timeDiff / 1000);
    const diffMinutes = Math.floor(diffSeconds / 60);
    const diffHours = Math.floor(diffMinutes / 60);
    const diffDays = Math.floor(diffHours / 24);

    let timeSinceEmailed = '';
    if (diffDays > 0) {
      timeSinceEmailed = `${diffDays} day${diffDays > 1 ? 's' : ''}`;
    }
    else if (diffHours > 0) {
      timeSinceEmailed = `${diffHours} hour${diffHours > 1 ? 's' : ''} ${diffMinutes - (60 * diffHours)} minute${diffMinutes - (60 * diffHours) > 1 ? 's' : ''}`;
    }
    else if (diffMinutes > 0) {
      timeSinceEmailed = `${diffMinutes} minute${diffMinutes > 1 ? 's' : ''}`;
    }
    else {
      timeSinceEmailed = `${diffSeconds} second${diffSeconds > 1 ? 's' : ''}`;
    }

    if (timeSinceEmailed.includes('NaN')) {
      return 'Not emailed yet';
    } else {
    return timeSinceEmailed;
    }
  }
  
  onFileSelected(event) {
    this.convertFile(event.target.files[0]).subscribe(base64 => {
      this.sendAuthorizationForm.value.authLetter = base64;
      this.fleetAuthService.uploadAuthLetter(this.authData.sfReference, {quoteId: this.authData.quoteId, authLetterBase64: this.sendAuthorizationForm.value.authLetter}).subscribe({
        next: (data: FleetAuthLetter) => {
          this.authData.authLetterBase64 = data.authLetterBase64;
          this.hasAuthLetter = true;
          this.notification.showSuccess('Fleet Auth Letter uploaded successfully!');
        },
        error: (error) => {
          this.notification.handleError(error);
        }
      });
    });
  }

  convertFile(file : File) : Observable<string> {
    const result = new ReplaySubject<string>(1);
    const reader = new FileReader();
    reader.readAsBinaryString(file);
    reader.onload = (event) => {
      if (event.target && event.target.result) {
        result.next(btoa(event.target.result.toString()));
      }
    };
    return result;
  }

  isImageViewerVisible: boolean = false;
  selectedImages: string[] | null = null;
  currentField: FleetAuthField | null = null;

  openFile(quoteId: number, fleetAuthFieldValueId: number): void {
    this.isLoading = true;
    this.fleetAuthService.getField(quoteId, fleetAuthFieldValueId).subscribe({
      next: (data: FleetAuthField) => {
        this.currentField = data;
        this.selectedImages = data.fleetAuthFieldValue;
        this.isImageViewerVisible = true
        this.isLoading = false;
      }
      , error: (error) => {
        this.notification.showError('Failed to fetch image.');
        this.isLoading = false;
      }
    });
  }
  closeImageViewer(): void {
    this.isImageViewerVisible = false;
    this.selectedImages = null;
  }

  emails = '';

  addEmail(): void {
    const emailList = this.emails
      .split(/[,;]/)
      .map(email => email.trim());
    if (emailList.every(email => email.includes('@'))) {
      const existingEmails = this.authData.emailAddresses ? this.authData.emailAddresses.split(/[,;]/).map(email => email.trim()) : [];
      const updatedEmails = Array.from(new Set([...existingEmails, ...emailList])); 
      this.authData.emailAddresses = updatedEmails.join(', ');
    } else {
      console.error('One or more emails are invalid.');
    }
  }
  sendAuth(sfReference: string): void {
    this.fleetAuthForm.isAuthorised = this.sendAuthorizationForm.value.isAuthorised;
    this.fleetAuthForm.authNumber = this.sendAuthorizationForm.value.authNumber;
    this.fleetAuthForm.message = this.sendAuthorizationForm.value.message;

    this.fleetAuthService.submitFleetAuthCallCentre(this.authData.quoteId, sfReference, this.fleetAuthForm).subscribe({
      next: (data: FleetAuth) => {
        this.notification.showSuccess('Fleet Auth Letter sent successfully!');
        this.authData.isAuthorised = this.sendAuthorizationForm.value.isAuthorised;
        this.authData.isLocked = true;

        if(this.sendAuthorizationForm.value.isAuthorised) {
          this.authData.isAuthorised = true;
          this.authData.authStatus = 'AUTHORIZED';
        }
        else {
          this.authData.isAuthorised = false;
          this.authData.authStatus = 'REJECTED';
        }
        this.authData.dtEmailed = new Date();
        this.timeSinceEmailed = this.calculateTimeSinceEmailed(new Date(this.authData.dtResponded + 'Z'), new Date(this.authData.dtEmailed + 'Z'));
      }
      , error: (error) => {
        this.notification.handleError(error);
      }
    });
  }

  changeAuthStatus(): void {
    const isAuthorised = this.sendAuthorizationForm.controls.isAuthorised.value;
    const authNumber = this.sendAuthorizationForm.controls.authNumber;

    if (isAuthorised === null) {
      this.updateStateId(5);
    } else {
      if (isAuthorised) {
        authNumber.addValidators(Validators.required);
      } else {
        authNumber.removeValidators(Validators.required);
      }

    }
    this.authData.isAuthorised = isAuthorised;
    authNumber.updateValueAndValidity();
  }

  updateStateId(stateId: number): void {
    this.isLoading = true;
    this.fleetAuthService.UpdateStateId(this.authData.quoteId, this.authData.sfReference, stateId).subscribe({
        next: (data) => {
          this.isLoading = false;
          this.notification.showSuccess('Auth Status Successfully Updated');
      }
      , error: (error) => {
        this.isLoading = false;
        this.notification.showError(error);
      }
    })
  }

  downloadQuote(){
    this.fleetAuthService.downloadQuoteDocument(this.authData.quoteId, this.authData.sfReference).subscribe({
      next: (data) => {
        this.downloadFile(data.content, data.title);
      }
      , error: (error) => {
        this.notification.showError(error);
      }
    });
  }

  downloadAuthLetter() {
      if (this.authData && this.authData.authLetterBase64) {
        this.downloadFile(this.authData.authLetterBase64, 'Authorisation Letter');
      }

  }
  downloadFile(source: string, fileName: string): void {
    if (source) {
      const link = document.createElement('a');
      link.href = 'data:application/pdf;base64,' + source;
      link.download = `${fileName}.pdf`; 
      link.click();
    } else {
      this.notification.showInfo('No file available to download.');
    }
  }

    openImageInNewTab(imageUrl: string): void {
  const newWindow = window.open();
  if (newWindow) {
    newWindow.document.write(`
      <html>
        <head><title>${this.currentField?.fleetAuthFieldName}</title></head>
        <body style="margin: 0; display: flex; justify-content: center; align-items: center; min-height: 100vh; background: #000;">
          <img src="${imageUrl}" style="max-width: 100%; max-height: 100%; object-fit: contain;" />
        </body>
      </html>
    `);
  }
}
}
